import React, { useState } from 'react';
import { ChevronRight, CheckCircle, Globe, Cog, Users, TrendingUp, Shield, Award, ArrowRight, Play, Cpu, Network, Brain, Sparkles, Database, Zap, Cloud, Target } from 'lucide-react';
import {Link,useNavigate} from 'react-router-dom';
import OSImage from '../../../../../Assets/InforPage/InforOs.jpg'
import InforAlliancesLogo from '../../../../../Assets/Logo/InforAlliancePartner.png'
import Intro from './IntroCarousel'
import WhyChooseus from './WhyChoose'
import InforOSFeatures from './InforOsFeatures';
import InforOSBenifits from './Benifits'
import IntroHero from '../../../ResuableComponents/IntroHero';
import ImageSectionReusable from '../../../ResuableComponents/ImageSectionResuable';
import OSInforgraphicImage from '../../../../../Assets/OS_infogrphic.png'
import { Helmet } from 'react-helmet';
import CTA from './CTA';
import OSOverview from './OSOverview';
import TechnologiesSection from './Technologies';
import InforOSIndustries from './Industries';
import InforOSFAQ from './FAQ';

const InforOSComponent = () => {
  const [activeFeature, setActiveFeature] = useState(0);
     const navigate = useNavigate();
      
        const handleClick = () => {
          navigate('/contact');
          // Scroll to top after navigation
          window.scrollTo(0, 0);
        };
      


  const handleContactClick = () => {
    // Navigation logic would go here
    console.log('Contact clicked');
  };

  return (
    <>
      <Helmet>
        {/* Primary Meta Tags */}
        <title>PTKCS Tech | InforOS – Intelligent Cloud Platform & Application Framework</title>
        <meta 
          name="description" 
          content="PTKCS Tech offers InforOS expertise—cloud-native application development, microservices, integration, extension, APIs, and platform operations. Empower your enterprise with scalable, connected digital ecosystems." 
        />
        <meta 
          name="keywords" 
          content="InforOS, Infor OS, cloud platform, application framework, Infor microservices, Infor integration, Infor extension, API integration, cloud native apps, enterprise platform, PTKCS Tech" 
        />
        
        {/* Open Graph / Facebook */}
        <meta property="og:type" content="website" />
        <meta property="og:title" content="PTKCS Tech | InforOS – Intelligent Cloud Platform & Application Framework" />
        <meta 
          property="og:description" 
          content="PTKCS Tech offers InforOS expertise—cloud-native application development, microservices, integration, extension, APIs, and platform operations. Empower your enterprise with scalable, connected digital ecosystems." 
        />
        <meta property="og:image" content="https://ik.imagekit.io/kqumni8l2/INFOR_SERVICES_IMAGES/infographic2.png?updatedAt=1760003585804" />
        
        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="PTKCS Tech | InforOS – Intelligent Cloud Platform & Application Framework" />
        <meta 
          name="twitter:description" 
          content="PTKCS Tech offers InforOS expertise—cloud-native application development, microservices, integration, extension, APIs, and platform operations. Empower your enterprise with scalable, connected digital ecosystems." 
        />
        <meta name="twitter:image" content="https://ik.imagekit.io/kqumni8l2/INFOR_SERVICES_IMAGES/infographic2.png?updatedAt=1760003585804" />
        
        {/* Additional SEO Tags */}
        <meta name="robots" content="index, follow" />
        <meta name="language" content="English" />
        <meta name="author" content="PTKCS Tech" />
        <link rel="canonical" href={window.location.href} />
      </Helmet>


    <div className="min-h-screen font-satoshi" style={{ backgroundColor: '#FFFFFF' }}>
            <Intro/>
      <OSOverview/>
      <InforOSFeatures/>
      <TechnologiesSection/>
      <InforOSIndustries/>
      <WhyChooseus/>
      <InforOSFAQ/>
      {/* CTA Section */}
      <CTA />
    </div>
    </>
  );
};

export default InforOSComponent;
